module.exports = __webpack_public_path__ + "img/security.cb92f156.png";